var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"mask",style:({ backgroundColor: _vm.bgColor }),on:{"click":function($event){$event.stopPropagation();return _vm.clickHandle.apply(null, arguments)}}}):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }